import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { Practice } from '../../../core/models/practice';
import { PracticeService } from '../../../core/services/practice.service';

@Injectable({ providedIn: 'root' })
export class PracticesStateService {
  private _practices$ = new BehaviorSubject<Practice[]>([]);
  private loaded = false;

  constructor(private practiceService: PracticeService) {}

  get practices$(): Observable<Practice[]> {
    if (!this.loaded) {
      this.load();
    }
    return this._practices$.asObservable();
  }

  getAll(): Practice[] {
    return this._practices$.getValue();
  }

  load(): void {
    this.practiceService.getPractices().subscribe({
      next: (practices) => {
        this._practices$.next(practices);
        this.loaded = true;
      },
      error: () => {
        this._practices$.next([]);
      },
    });
  }

  add(name: string): Observable<Practice> {
    return this.practiceService.addPractice({ id: 0, name }).pipe(
      tap((practice) => {
        this._practices$.next([...this._practices$.getValue(), practice]);
      }),
    );
  }

  update(id: number, name: string): Observable<Practice> {
    return this.practiceService.updatePractice({ id, name }).pipe(
      tap((practice) => {
        this._practices$.next(
          this._practices$.getValue().map((p) => (p.id === id ? practice : p)),
        );
      }),
    );
  }

  delete(id: number): Observable<void> {
    return this.practiceService.deletePractice(id).pipe(
      tap(() => {
        this._practices$.next(this._practices$.getValue().filter((p) => p.id !== id));
      }),
    );
  }
}
